export var SubType;
(function (SubType) {
  SubType["REQUEST_COMMISSION_UPDATE"] = "request_commission_update";
  SubType["DELAYED_MISSING_PAYOUT"] = "delayed_missing_payout";
})(SubType || (SubType = {}));